/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */
import {VisitorRequestMainApp} from "./Functionality/VisitorRequestMainApp";
import React from "react";
import RequestInvitations from "./SubComponents/RequestInvitations";
import InvitationStatus from "./SubComponents/InvitationStatus";
import {VISITOR_SUB_VIEW_MODEL} from "../Invitation/Model/Model";

const VisitorRequestMain = (props) => {

    const {
        subView,
        setSubView,
        selectedList,
        setSelectedList,
        searchElement,
        setSearchElement,
        criteria,
        setCriteria,
        setBodyForExport,
        finalArray,
        setFinalArray,
        search,
        setSearch,
        setOption,
        modified,
        setModified
    } = props;

    const { handleChangeView } = VisitorRequestMainApp({
        setSubView,
        setOption,
        setSearchElement,
        setFinalArray,
        setSearch,
    });

    return (
        <>
            {subView === VISITOR_SUB_VIEW_MODEL.REQUESTS.REQUESTED_INVITATIONS &&
                <RequestInvitations
                    selectedList={selectedList}
                    setSelectedList={setSelectedList}
                    subView={subView}
                    handleSubViewChange={handleChangeView}
                    setCriteria={setCriteria}
                    setBodyForExport={setBodyForExport}
                    searchElement={searchElement}
                    setSearchElement={setSearchElement}
                    finalArray={finalArray}
                    setFinalArray={setFinalArray}
                    search={search}
                    setSearch={setSearch}
                    criteria={criteria}
                    modified={modified}
                    setModified={setModified}
                />
            }
            {subView === VISITOR_SUB_VIEW_MODEL.REQUESTS.INVITATION_STATUS &&
                <InvitationStatus
                    selectedList={selectedList}
                    setSelectedList={setSelectedList}
                    subView={subView}
                    handleSubViewChange={handleChangeView}
                    setCriteria={setCriteria}
                    setBodyForExport={setBodyForExport}
                    searchElement={searchElement}
                    setSearchElement={setSearchElement}
                    finalArray={finalArray}
                    setFinalArray={setFinalArray}
                    search={search}
                    setSearch={setSearch}
                    criteria={criteria}
                    modified={modified}
                    setModified={setModified}
                />
            }

        </>
    )

}

export default VisitorRequestMain
